/* [UCAR Webdesign] Warenkorb Upsell-Popup */
(function () {
  if (window.bdCartUpsellInit) return;
  window.bdCartUpsellInit = true;

  var pendingAdd = false;
  var pendingExpire = null;
  var attemptTimer = null;
  var lastItemCount = null;

  function getSource() {
    return document.querySelector('cart-drawer [data-bd-upsell-popup]');
  }

  function getActive() {
    return document.querySelector('body > [data-bd-upsell-popup]');
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function openPopup() {
    if (getActive()) return;
    var source = getSource();
    if (!source) return;

    var popup = source.cloneNode(true);
    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.body.appendChild(popup);

    var container = popup.querySelector('.bd-cart-upsell-popup__container');
    if (container) container.focus({ preventScroll: true });
  }

  function closePopup() {
    var popup = getActive();
    if (popup) popup.remove();
  }

  function clearPending() {
    pendingAdd = false;
    if (pendingExpire) {
      clearTimeout(pendingExpire);
      pendingExpire = null;
    }
  }

  function attempt() {
    if (!pendingAdd) return;
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('active')) return;
    if (!getSource()) return;
    clearPending();
    openPopup();
  }

  function attemptSoon() {
    if (attemptTimer) clearTimeout(attemptTimer);
    attemptTimer = setTimeout(function () {
      attemptTimer = null;
      attempt();
    }, 500);
  }

  function markAdd() {
    pendingAdd = true;
    if (pendingExpire) clearTimeout(pendingExpire);
    pendingExpire = setTimeout(function () {
      pendingAdd = false;
    }, 6000);
    attemptSoon();
  }

  function isAddEvent(event) {
    if (!event) return false;

    if (event.source === 'product-form' || event.source === 'quick-add') {
      lastItemCount = null;
      return true;
    }

    if (!event.source && event.variantId) {
      lastItemCount = null;
      return true;
    }

    var cart = event.cartData;
    if (cart && typeof cart.item_count === 'number') {
      var previous = lastItemCount;
      lastItemCount = cart.item_count;
      return previous !== null && cart.item_count > previous;
    }

    return false;
  }

  function watchDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    if (drawer.classList.contains('is-empty')) {
      lastItemCount = 0;
    } else {
      var inputs = drawer.querySelectorAll('.quantity__input');
      if (inputs.length) {
        var sum = 0;
        inputs.forEach(function (input) {
          sum += parseInt(input.value, 10) || 0;
        });
        lastItemCount = sum;
      }
    }

    var wasActive = drawer.classList.contains('active');

    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');

      if (isActive && !wasActive) attemptSoon();

      if (!isActive && wasActive) {
        clearPending();
        closePopup();
      }

      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    new MutationObserver(function () {
      if (getActive() && !getSource()) closePopup();
      if (pendingAdd) attemptSoon();
    }).observe(drawer, { childList: true, subtree: true });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (isAddEvent(event)) markAdd();
      });
    }
  }

  function renderCartIconBubble(sectionHtml) {
    if (!sectionHtml) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var source = doc.querySelector('.shopify-section');
    if (source) bubble.innerHTML = source.innerHTML;
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-icon-bubble' })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Cart error');

        button.classList.remove('loading');
        closePopup();

        var source = getSource();
        if (source) source.remove();

        if (data.sections) renderCartIconBubble(data.sections['cart-icon-bubble']);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { cartData: data, variantId: variantId });
        }
      })
      .catch(function (error) {
        console.error('[BD Upsell] Error adding to cart:', error);
        button.classList.remove('loading');
      });
  }

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest('[data-bd-upsell-add]');
    if (addButton) {
      if (!addButton.classList.contains('loading')) addToCart(addButton);
      return;
    }

    if (event.target.closest('[data-bd-upsell-close]')) closePopup();
  });

  document.addEventListener('keyup', function (event) {
    if (event.code !== 'Escape') return;
    if (getActive()) {
      closePopup();
      event.stopPropagation();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();
